<p-toast></p-toast>
<div class="document-file-upload">
  <!-- Upload Section Label -->
  <div class="upload-section-header">
    <h5 class="section-title">{{ 'Files' | translate }}</h5>
    <p class="section-description">{{ 'File upload' | translate }}</p>
  </div>

  <!-- Initial loading for existing file info -->
  <app-loading *ngIf="initialLoading" [loading]="true" [width]="'48px'" [height]="'48px'"></app-loading>

  <ng-container *ngIf="!initialLoading">
  <!-- File Upload Area -->
  <div *ngIf="!fileInfo" class="file-upload-area" 
       [class.dragging]="draggedFile"
       (dragover)="onDragOver($event)"
       (dragleave)="onDragLeave($event)"
       (drop)="onDrop($event)">
      <label class="upload-content">
      <input type="file" 
             #fileInput 
             (change)="onFileSelected($event)"
             style="display: none">
      <p class="upload-text">{{ 'Drag and drop files here or' | translate }}<br>{{ 'Select files to upload' | translate }}</p>
    </label>
  </div>

  <!-- Upload Progress -->
  <div *ngIf="uploading" class="upload-progress-container">
    <div class="upload-progress-bar">
      <div class="progress-fill" [style.width.%]="uploadProgress"></div>
    </div>
    <div class="progress-info">
      <span class="progress-text">{{ uploadProgress }}%</span>
      <i class="ri-loader-2-line progress-icon"></i>
    </div>
  </div>

  <!-- Uploaded Files Header -->
  <div *ngIf="fileInfo && !uploading" class="uploaded-files-header">
    <h5 class="section-title">{{ 'Uploaded files' | translate }}</h5>
  </div>

  <!-- File Info Section -->
  <div *ngIf="fileInfo && !uploading" class="file-info-container">
    <div class="file-card">
      <div class="file-icon-container">
        <!-- PDF Icon -->
        <img *ngIf="fileInfo.fileFormat === 'PDF'" 
             src="assets/icons/main/light/file-pdf-icon.svg" 
             alt="PDF" 
             class="file-type-icon">
        <!-- Default file icon -->
        <svg *ngIf="fileInfo.fileFormat !== 'PDF'" class="file-type-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
          <polyline points="13 2 13 9 20 9"></polyline>
        </svg>
      </div>
      <div class="file-info">
        <p class="file-name" [title]="fileInfo.fileName">{{ fileInfo.fileName }}</p>
        <p class="file-format">
          {{ fileInfo.fileFormat }}
          <span *ngIf="fileInfo.fileSize > 0" class="file-size">
            • {{ formatFileSize(fileInfo.fileSize) }}
          </span>
        </p>
      </div>
      <div class="file-actions">
        <button 
          pButton
          class="action-btn download-btn" 
          (click)="downloadFile()" 
          type="button" 
          [pTooltip]="'Download' | translate"
          icon="pi pi-download">
        </button>
        <button 
          pButton
          class="action-btn remove-btn" 
          (click)="removeFile()" 
          type="button"
          [pTooltip]="'Delete' | translate"
          icon="pi pi-trash">
        </button>
      </div>
    </div>
  </div>
  </ng-container>
</div>